module.exports = __webpack_public_path__ + "img/aboutUs_img4.947c5002.svg";